import {
  InlineFormContainer,
  AuthenticationToolsContainer,
  PageSSRContainer,
} from '@stepstone-fragment/login-registration';
import { EndpointClient } from 'types/endpoint';

export const containersClient: EndpointClient[] = [
  {
    name: 'form',
    serverRender: true,
    container: InlineFormContainer,
  },
  {
    name: 'pagessr',
    serverRender: true,
    container: PageSSRContainer,
  },
  {
    name: 'authenticationTools',
    serverRender: false,
    container: AuthenticationToolsContainer,
  },
];
